import {createAction} from "../../factory/redux/action";

export const ACTION_TYPE = Object.freeze({
    SET_LANG:"SET_LANG"
});

export const SET_LANG = (payload) => createAction(
    ACTION_TYPE.SET_LANG,
    payload
);